/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["src"];
import api from '@/service/backend';
import { useUserStore } from '@/store/user';
import { formatImgUrl } from '@/utils/formatter';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-nft-image',
  props: {
    imageUrl: {
      default: ''
    },
    chainId: null,
    contractAddress: null,
    tokenId: {
      default: ''
    }
  },
  emits: ["openseaUrl", "name"],

  setup(__props, {
    emit: $emit
  }) {
    const props = __props;
    const isDark = useDark();
    const noError = ref(false);
    const nft = reactive({
      imageUrl: ''
    });

    const imgError = () => {
      noError.value = true;
    };

    const loadImageUrl = async () => {
      const address = useUserStore().accountInfo.address;

      if (!(props.contractAddress && props.chainId)) {
        return;
      }

      try {
        const res = await api.getAccountNFTImage({
          address,
          contractAddress: props.contractAddress || '',
          chainId: props.chainId,
          tokenId: props.tokenId
        });
        const {
          imageUrl,
          openseaUrl,
          name
        } = res.data;
        nft.imageUrl = formatImgUrl(imageUrl);
        $emit('openseaUrl', openseaUrl);
        $emit('name', name);
      } catch (error) {//
      }
    };

    onBeforeMount(() => {
      const {
        imageUrl
      } = props;

      if (imageUrl) {
        nft.imageUrl = formatImgUrl(imageUrl);
      } else {
        loadImageUrl();
      }
    });
    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["up-nft-image", {
          collection: !props.tokenId
        }])
      }, [nft.imageUrl && !noError.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: nft.imageUrl,
        onError: imgError
      }, null, 40, _hoisted_1)) : (_openBlock(), _createBlock(_component_up_icon, {
        key: 1,
        name: `${props.tokenId ? 'nft' : 'collection'}-${_unref(isDark) ? 'dark' : 'light'}`
      }, null, 8, ["name"]))], 2);
    };
  }

});